import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

interface OcErrorBoundaryInfoProps {
  error: Error;
  errorInfo: { componentStack: string };
}

export const OcErrorBoundaryInfo: React.FC<OcErrorBoundaryInfoProps> = ({
  error,
  errorInfo,
}) => {
  const { t } = useTranslation();

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      border="1px solid red"
      padding="8px 16px"
    >
      <Box paddingBottom="8px">
        <span style={{ marginRight: "36px" }}>{t("OC_ERROR_TEXT")}</span>
        <button
          type="button"
          onClick={handleReload}
          style={{
            color: "#cc0033",
            cursor: "pointer",
            textDecoration: "underline",
            background: "none",
            border: "none",
            padding: 0,
            font: "inherit",
          }}
        >
          {t("OC_RELOAD_PAGE")}
        </button>
      </Box>
      <Box>
        <details style={{ whiteSpace: "pre-wrap" }}>
          {error && error.toString()}
          <br />
          {errorInfo.componentStack}
        </details>
      </Box>
    </Box>
  );
};

export default OcErrorBoundaryInfo;
